<template>
  <view>
    <view>switch-position 属性修改 switch 文案位置</view>
    <view class="bg-white">
      <cube-collapse switch-positon="{{ 'bottom' }}" switch-text="查看更多" min-height="{{ '40px' }}">
        <view class="text">1. 吃好喝好</view>
        <view class="text">2. 睡前少玩手机</view>
        <view class="text">3. 定闹钟早起</view>
        <view class="text">4. 上面的理论来自个人猜想</view>
      </cube-collapse>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({})
</script>

<style lang="stylus" scoped>
.bg-white
  margin-top: 6px
  background-color: #fff
.text
  line-height: 20px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-collapse": "@mpxjs/mpx-cube-ui/src/components/collapse/index"
    }
  }
</script>
